/**
 * File: TooltipIconButton.tsx
 * Description: Tooltip icon button component for assistant-ui
 * Author: System
 * Created: 2025-09-03
 * Last Modified: 2025-09-03
 */

import React from 'react';

import { cn } from '../../shared/utils';

interface TooltipIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  tooltip: string;
  variant?: 'default' | 'outline' | 'ghost';
}

export const TooltipIconButton: React.FC<TooltipIconButtonProps> = ({
  tooltip,
  variant = 'ghost',
  className,
  children,
  ...props
}) => {
  const variantClasses = {
    default: 'bg-primary text-primary-content hover:bg-primary/80',
    outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
    ghost: 'hover:bg-accent hover:text-accent-foreground',
  };

  return (
    <button
      type='button'
      title={tooltip}
      className={cn(
        'inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50',
        'h-8 w-8 p-1',
        variantClasses[variant],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
